import { ROUTES, TITLES, PROD, STAGE, DEV } from 'consts';

export const UPDATES_MENU = {
  key: ROUTES.UPDATES.ROOT,
  label: TITLES[ROUTES.UPDATES.ROOT],
  environment: [DEV, STAGE, PROD],
};
